import InputText from "@/components/input-text/InputText";
import InputCheckbox from "@/components/input-checkbox/InputCheckbox";
import InputDatePicker from "@/components/input-date-picker/InputDatePicker";
import {KeycloakService} from "@/services/keycloak.service";
import InputDropdown from "@/components/input-dropdown/InputDropdown.vue";
import moment from 'moment'
import {value} from "lodash/seq";
import booking from "@/views/booking/booking";
import bookingOption from "@/views/settings/booking-option/booking-option";
import {BookingOption} from "@/services/booking.service";

export default {
    name: 'BookingOptionsContainer',

    components: {
        InputText,
        InputCheckbox,
        InputDatePicker,
        InputDropdown
    },

    props: {
        value: Array,
        booking: undefined
    },

    computed: {
      sortValues() {
          return this.groupById(this.value)
      }
    },


    methods: {
        bookingOptionIsOfType(bookingOption, type) {
            if (type.toLowerCase() == bookingOption.type?.toLowerCase()) {
                return true
            }
            return false
        },

        toggleBookingOption(bookingOption) {
            bookingOption.value = !bookingOption.value
        },

        checkForError () {
            for (const ref in this.$refs) {
                const component = this.$refs[ref] && this.$refs[ref][0] ? this.$refs[ref][0] : this.$refs[ref]
                if (component != undefined && !Array.isArray(component)) {
                    if (component.checkForError()) {
                        return true // return error
                    }
                }
            }
            return false
        },

        showIfForSuperUser (bookingOption) {
            if (bookingOption.isForSuperUser === true) {
                if (!KeycloakService.isBookingAgent()) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        updateBookingOptionDate(event, bookingOption) {
            bookingOption.value = moment(event).format('YYYY-MM-DD HH:mm:ss')
        },

        updateDropdownValue (id, bookingOption) {
            bookingOption.value = bookingOption.options[id]
        },
        groupById(array) {
            const groupedItems = array.reduce((result, item) => {
                if (!result[item.id]) {
                    result[item.id] = [];
                }
                result[item.id].push(item);
                return result;
            }, {});
            return Object.values(groupedItems).flat()
        },

        addOption(option) {
            const opt = new BookingOption(option);
            opt.value = undefined;
            opt.original = false;
            this.$emit('input', [...this.value, opt])
        },

        removeOption(option) {
            this.$emit('input', this.value.filter(bookingOption => option !== bookingOption));
        },

        allowedToDuplicate (option) {
            return !option.isGenerated && !this.bookingOptionIsOfType(option, 'select') && this.showIfForSuperUser(option) && option.original
        },

        allowedToRemove (option) {
            return !option.original
        }
    }
}
